import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";

export class DriverSettlementFormSettingModel extends EntityBase {
    public  CostId :number;
    public CostGroupId : number;
    public DeductionForSettlement : boolean;
    constructor(){
      super();
      this.CostGroupId = 0;
      this.CostId = 0;
      this.DeductionForSettlement = false;
    }
}